import { apiClient } from "./client";
import type { AddressResponse, CreateAddressRequest, UpdateAddressRequest } from "./addresses/types";

/**
 * Get a single address by ID
 */
export const getAddress = async (id: string): Promise<AddressResponse> => {
    const { data } = await apiClient.get<AddressResponse>(`/addresses/${id}`);
    return data;
};

/**
 * Create a new address
 */
export const createAddress = async (request: CreateAddressRequest): Promise<AddressResponse> => {
    const { data } = await apiClient.post<AddressResponse>("/addresses", request);
    return data;
};

/**
 * Update an existing address
 */
export const updateAddress = async (
    id: string,
    request: UpdateAddressRequest
): Promise<AddressResponse> => {
    const { data } = await apiClient.patch<AddressResponse>(`/addresses/${id}`, request);
    return data;
};

/**
 * Delete (soft delete) an address
 */
export const deleteAddress = async (id: string): Promise<void> => {
    await apiClient.delete(`/addresses/${id}`);
};